// import { useState } from 'react';
// import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaShieldAlt, FaGlobe, FaChartLine, FaCoins } from 'react-icons/fa';

// const HomePage = () => {
//   const [email, setEmail] = useState('');

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Add your email submission logic here
//     console.log('Email submitted:', email);
//     setEmail('');
//   };

//   const services = [
//     {
//       icon: <FaCoins className="w-12 h-12 mb-4 text-yellow-500" />,
//       title: "Bullion Trading",
//       description: "Global trading of gold and silver bullion with competitive pricing"
//     },
//     {
//       icon: <FaShieldAlt className="w-12 h-12 mb-4 text-yellow-500" />,
//       title: "Secure Logistics",
//       description: "Armored transport and insured shipping worldwide"
//     },
//     {
//       icon: <FaChartLine className="w-12 h-12 mb-4 text-yellow-500" />,
//       title: "Market Analytics",
//       description: "Real-time precious metals market insights and forecasting"
//     },
//     {
//       icon: <FaGlobe className="w-12 h-12 mb-4 text-yellow-500" />,
//       title: "Global Network",
//       description: "Established partnerships across 25+ countries"
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white">
//       <div className="container mx-auto px-4 py-16">
//         {/* Header */}
//         <div className="text-center mb-20">
//           <h1 className="text-5xl md:text-7xl font-bold mb-6">
//             <span className="bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
//               PVG
//             </span>
//             <span className="bg-gradient-to-r from-gray-300 to-gray-100 bg-clip-text text-transparent">
//               {" "}Import
//             </span>
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-300 mb-8">
//             Pioneering Global Precious Metals Trade
//           </p>
//         </div>

//         {/* Services Preview */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
//           {services.map((service, index) => (
//             <div 
//               key={index}
//               className="p-8 bg-gray-800 rounded-xl transform transition-all hover:-translate-y-2 hover:shadow-xl"
//             >
//               <div className="text-center">
//                 {service.icon}
//                 <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
//                 <p className="text-gray-400">{service.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Stats Section */}
//         {/* <div className="bg-gray-800 rounded-2xl p-8 mb-20">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
//             <div className="p-6">
//               <div className="text-4xl font-bold text-yellow-500 mb-2">25+</div>
//               <div className="text-gray-400">Countries Served</div>
//             </div>
//             <div className="p-6">
//               <div className="text-4xl font-bold text-yellow-500 mb-2">$1B+</div>
//               <div className="text-gray-400">Annual Trade Volume</div>
//             </div>
//             <div className="p-6">
//               <div className="text-4xl font-bold text-yellow-500 mb-2">98%</div>
//               <div className="text-gray-400">Client Retention</div>
//             </div>
//             <div className="p-6">
//               <div className="text-4xl font-bold text-yellow-500 mb-2">24/7</div>
//               <div className="text-gray-400">Market Monitoring</div>
//             </div>
//           </div>
//         </div> */}

//         {/* Email Subscription */}
//         <div className="max-w-2xl mx-auto mb-20">
//           <div className="text-center">
//             <h2 className="text-3xl md:text-4xl font-bold mb-6">
//               Get Exclusive Market Insights
//             </h2>
//             <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-4">
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Enter your professional email"
//                 className="flex-1 px-6 py-4 rounded-full bg-gray-800 border border-gray-700 focus:outline-none focus:border-yellow-500"
//                 required
//               />
//               <button
//                 type="submit"
//                 className="px-8 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-full font-semibold hover:from-yellow-600 hover:to-yellow-700 transition-all"
//               >
//                 Join Priority List
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Social Links */}
//         {/* <div className="flex justify-center gap-6 text-2xl">
//           <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
//             <FaFacebook />
//           </a>
//           <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
//             <FaTwitter />
//           </a>
//           <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
//             <FaInstagram />
//           </a>
//           <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
//             <FaLinkedin />
//           </a>
//         </div> */}

//         {/* Footer */}
//         <div className="mt-16 text-center text-gray-400">
//           <p>© 2025 PVG Import. All rights reserved.</p>
//           <p className="mt-2">info@pvgimportexport.com.au</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;

import React, { useState, useEffect } from 'react';
import hero1 from '../assets/gold1.jpg'
import logo1 from '../assets/1.png'
import logo2 from '../assets/2.png'
const HomePage = () => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  
  // Set launch date (30 days from now)
  useEffect(() => {
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 30);
    
    const timer = setInterval(() => {
      const now = new Date();
      const difference = launchDate - now;
      
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      setCountdown({ days, hours, minutes, seconds });
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);
  
  // Email subscription form handling
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setEmail('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white font-sans">
      {/* Header */}
      <header className="flex items-center justify-center text-center p-6 md:p-8">
  <div className="flex items-center text-center">
  <img src={logo1} className="md:h-24 " />
    {/* <div className="h-10 w-10 bg-yellow-500 rounded-full"></div> */}
    {/* <h1 className="mx-3 text-xl font-bold">PVG IMPORT</h1> */}
    {/* <div className="h-10 w-10 bg-zinc-300 rounded-full"></div> */}
  </div>
</header>


      {/* Hero Section */}
      <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">Global Gold and Silver Trading Excellence</h2>
            <p className="text-lg text-gray-300 mb-8">
              Setting new standards in precious metals import & export. Launching soon with exclusive partnership opportunities.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              {/* <button className="px-6 py-3 bg-yellow-500 hover:bg-yellow-600 rounded text-black font-bold transition">
                Join Waitlist
              </button>
              <button className="px-6 py-3 border border-yellow-500 rounded hover:bg-gray-800 transition">
                Learn More
              </button> */}
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            {/* <div className="w-full max-w-md h-64 md:h-96 rounded-lg bg-gradient-to-r from-yellow-400 to-yellow-600 flex items-center justify-center">
              <div className="text-center">
                <div className="text-4xl md:text-6xl font-bold text-black">
                  GOLD
                </div>
                <div className="text-sm md:text-base mt-2 text-black font-medium">
                  INTERNATIONAL TRADE
                </div>
              </div>
            </div> */}
            < img src={hero1} className='w-full max-w-lg h-full md:h-96 md:ml-10 rounded-lg '/>
          </div>
        </div>
      </section>

      {/* Countdown Section */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h3 className="text-2xl md:text-4xl font-bold ">Launching Soon ...</h3>
          {/* <div className="flex justify-center space-x-4 md:space-x-8">
            <div className="w-16 md:w-24 h-16 md:h-24 bg-gray-800 rounded-lg flex flex-col items-center justify-center">
              <span className="text-xl md:text-3xl font-bold">{countdown.days}</span>
              <span className="text-xs md:text-sm text-gray-400">Days</span>
            </div>
            <div className="w-16 md:w-24 h-16 md:h-24 bg-gray-800 rounded-lg flex flex-col items-center justify-center">
              <span className="text-xl md:text-3xl font-bold">{countdown.hours}</span>
              <span className="text-xs md:text-sm text-gray-400">Hours</span>
            </div>
            <div className="w-16 md:w-24 h-16 md:h-24 bg-gray-800 rounded-lg flex flex-col items-center justify-center">
              <span className="text-xl md:text-3xl font-bold">{countdown.minutes}</span>
              <span className="text-xs md:text-sm text-gray-400">Minutes</span>
            </div>
            <div className="w-16 md:w-24 h-16 md:h-24 bg-gray-800 rounded-lg flex flex-col items-center justify-center">
              <span className="text-xl md:text-3xl font-bold">{countdown.seconds}</span>
              <span className="text-xs md:text-sm text-gray-400">Seconds</span>
            </div>
          </div> */}
        </div>
      </section>
      
      {/* Services Preview */}
      <section id="services" className="py-16 md:py-24 px-4 max-w-6xl mx-auto">
        <h3 className="text-2xl md:text-3xl font-bold mb-10 text-center">Our Premium Services</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gray-800 p-6 rounded-lg hover:bg-gray-700 transition">
            <div className="h-12 w-12 bg-yellow-500 rounded-md mb-4 flex items-center justify-center">
              <div className="text-black font-bold text-lg">1</div>
            </div>
            <h4 className="text-xl font-bold mb-3">Gold and Silver Import</h4>
            <p className="text-gray-300">Premium gold and silver sourcing from ethical mining operations worldwide with secure transportation.</p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg hover:bg-gray-700 transition">
            <div className="h-12 w-12 bg-zinc-300 rounded-md mb-4 flex items-center justify-center">
              <div className="text-black font-bold text-lg">2</div>
            </div>
            <h4 className="text-xl font-bold mb-3">Gold and Silver Export</h4>
            <p className="text-gray-300">Strategic export solutions with comprehensive documentation and regulatory compliance.</p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg hover:bg-gray-700 transition">
            <div className="h-12 w-12 bg-yellow-500 rounded-md mb-4 flex items-center justify-center">
              <div className="text-black font-bold text-lg">3</div>
            </div>
            <h4 className="text-xl font-bold mb-3">Trade Consulting</h4>
            <p className="text-gray-300">Expert guidance on global markets, regulations, and investment opportunities in precious metals.</p>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      {/* <section id="contact" className="py-16 bg-black px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">Be First to Know When We Launch</h3>
          <p className="text-gray-300 mb-8">
            Subscribe to receive exclusive offers and updates about our launch.
          </p>
          {submitted ? (
            <div className="bg-green-900 text-green-100 p-4 rounded-lg">
              Thank you for subscribing! We'll keep you updated.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-grow px-4 py-3 bg-gray-800 rounded text-white border-2 border-gray-700 focus:border-yellow-500 focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button 
                type="submit"
                className="px-6 py-3 bg-yellow-500 hover:bg-yellow-600 rounded text-black font-bold transition"
              >
                Notify Me
              </button>
            </form>
          )}
        </div>
      </section> */}

      {/* Footer */}
      <footer className="py-8 px-4 bg-black">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-6 md:mb-0">
            <img src={logo2} className="md:h-24 w-full" />
            {/* <div className="h-8 w-8 bg-yellow-500 rounded-full"></div>
            <span className="mx-2 text-lg font-bold">PVG IMPORT</span>
            <div className="h-10 w-10 bg-zinc-300 rounded-full"></div> */}
          </div>
          <div className="flex space-x-4 mb-6 md:mb-0">
            {/* <a href="#" className="text-gray-400 hover:text-white transition">
              <span className="sr-only">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition">
              <span className="sr-only">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition">
              <span className="sr-only">Instagram</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a> */}
          </div>
          <div className="text-sm text-gray-400">
            © 2025 PVG Import Export. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;